import { inject } from '@angular/core';
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { ProjectStore } from '@ffx/app-store';

export function uniqueProjectNameValidator(thisProjectId?: string): ValidatorFn {
    const projectStore = inject(ProjectStore);
    const allProjects = projectStore.dashboardProjects;
    return (control: AbstractControl): ValidationErrors | null => {
        const nameExists = allProjects().some(
            (project) => project.name === control.value && (!thisProjectId || thisProjectId !== project.id)
        );
        return nameExists ? { duplicateProjectName: control.value } : null;
    };
}
